import React, {Component, MutableRefObject, } from "react";

import AceEditor, {IMarker} from "react-ace";
import KnitMode from "./knit-mode";
import {Annotation} from "react-ace/types";
import {Button, Row, Space} from "antd";
import {EventService} from "../services/eventService";
import {SyncOutlined, RedoOutlined, UndoOutlined} from "@ant-design/icons";

type State = {
    text: string
}

type Props = {
    taskId: string,
    userId: string,
    onChange: (text: string) => void
    errors: Annotation[],
    markers: IMarker[],
    initialText: string
}

type ClassInfo = {
    taskId: string,
    userId: string,
    mouseEvents: any
}

class Editor extends Component<Props, State> {
    private mouseEvents: any = {};
    private history: string[] = [];
    private future: string[] = [];
    private resetFuture = true;
    private eventService = new EventService();

    constructor(props: Props) {
        super(props);
        this.state = {
            text: props.initialText
        };
        this.props.onChange(this.state.text);
        this.history.push(props.initialText);
    }

    componentWillReceiveProps = (nextProps: Props) => {
        if (nextProps.initialText !== this.props.initialText) {
            this.setState({text: nextProps.initialText});
        }
    }

    handleMouseEnter(event: any, classInfo: ClassInfo) {
        if (event.target.classList.contains("ace_error")) {
            const line = event.target.innerText as string;
            if (line) {
                classInfo.mouseEvents[line] = new Date();
            }
        }
    }
    handleMouseOut(event: any, classInfo: ClassInfo,
                   errors: Annotation[]) {
        if (event.target.classList.contains("ace_error")) {
            const line = event.target.innerText as string;
            if (line && classInfo.mouseEvents[line]) {
                const date = new Date();
                const timeElapsed = date.getTime() - classInfo.mouseEvents[line].getTime();
                if (timeElapsed > 500) {
                    const eventService = new EventService();
                    const date = new Date();

                    let tooltipText = ""
                    for(const error of errors) {
                        if ((error.row + 1) === Number(line)) {
                            tooltipText = error.text;
                        }
                    }
                    eventService.saveEvent(
                        classInfo.userId,
                        classInfo.taskId,
                        {
                            id: date.valueOf(),
                            time: date.toString(),
                            type: "ERROR_INSPECTOR",
                            value: {
                                line,
                                message: tooltipText,
                                hoverTime: timeElapsed,
                                startTime: classInfo.mouseEvents[line].getTime(),
                                endTime: date.getTime()
                            }
                        });
                }
            }
        }
    }

    componentDidMount() {
        const customMode = new KnitMode();
        (this.refs.aceEditor as any).editor.getSession().setMode(customMode);

        const eventInfo: ClassInfo = {
            mouseEvents: this.mouseEvents,
            userId: this.props.userId,
            taskId: this.props.taskId
        }

        // Bind the event listener
        document.getElementsByClassName('ace_gutter')[0].addEventListener("mouseover", (event) => this.handleMouseEnter(event, eventInfo));
        document.getElementsByClassName('ace_gutter')[0].addEventListener("mouseout", (event) => this.handleMouseOut(event, eventInfo, this.props.errors));
    }

    componentWillUnmount() {
        // document.getElementsByClassName('ace_gutter')[0].removeEventListener("hover", (e) => {this.handleHover(e)});
    }

    handleReset() {
        if (this.state.text != this.props.initialText) {
            this.setState({text: this.props.initialText});
            this.saveEvent("RESET", this.props.initialText);
        }
    }

    handleUndo() {
        if (this.history.length > 1) {
            this.resetFuture = false;
            const currentText = this.history.pop()!;
            const previousText = this.history.pop()!;
            this.future.push(currentText);
            this.setState({text: previousText});
            this.saveEvent("UNDO", previousText)
        }
    }

    handleRedo() {
        if (this.future.length > 0) {
            this.resetFuture = false;
            const futureText = this.future.pop()!;
            this.setState({text: futureText});
            this.saveEvent("REDO", futureText);
        }
    }

    handleEdit(content: string) {
        if (this.resetFuture) {
            this.future = [];
        } else {
            this.resetFuture = true;
        }
        this.history.push(content);
        this.setState({text: content});
        this.props.onChange(content);
    }

    private saveEvent(type: "UNDO" | "REDO" | "RESET", value: string) {
        const date = new Date();
        this.eventService.saveEvent(this.props.userId, this.props.taskId, {
            id: date.getTime(),
            type: type,
            time: date.toString(),
            value
        });
    }

    render() {
        return (
            <>
                <Row>
                    <Space direction="horizontal">
                        <Button type="primary" onClick={()=> {this.handleUndo()}} icon={<UndoOutlined />}>Undo</Button>
                        <Button type="primary" onClick={()=> {this.handleRedo()}} icon={<RedoOutlined />}>Redo</Button>
                        <Button type="primary" onClick={() => this.handleReset()} icon={<SyncOutlined />} >Reset</Button>
                    </Space>
                </Row>
                <Row style={{"padding": "16px 0px 0px 0px"}}>
                    <AceEditor
                        width='100%'
                        ref="aceEditor"
                        value={this.state.text}
                        markers={this.props.markers}
                        annotations={this.props.errors}
                        mode="text"
                        name="UNIQUE_ID_OF_DIV"
                        editorProps={{ $blockScrolling: true }}
                        debounceChangePeriod={200}
                        onChange={(content) => { this.handleEdit(content)}}
                        fontSize={16}
                        maxLines={40}
                    />
                </Row>
            </>
        );
    }
}

export default Editor;